import React from 'react';
import { AuthorizationPanel } from '../components/AuthorizationPanel';

export const AutorizacionPage: React.FC = () => {
  return <AuthorizationPanel />;
};
